<template>
  <svg
    width="131"
    height="30"
    viewBox="0 0 131 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0 30H29.9982V0H0V30ZM19.2267 2.29157C24.5292 4.02914 28.3604 9.05581 28.3752 14.9944C28.3894 20.8367 24.6349 25.8516 19.2267 27.7037V2.29157ZM14.9938 1.61237C15.9518 1.61237 16.9717 1.73993 17.8222 1.90885C17.8222 8.70558 11.2493 14.2987 4.465 14.2987L1.6283 14.2945C2.09311 7.3271 7.85805 1.61237 14.9938 1.61237ZM4.46737 15.7138C11.2499 15.7138 17.821 21.3009 17.821 28.0917C16.9717 28.2654 15.9016 28.3935 14.9938 28.3935C7.85569 28.3841 1.89585 22.651 1.62594 15.7143H4.46737V15.7138Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M40.0391 17.6372V15.7467H46.2806V13.3352H40.0379V9.82526H46.6787V7.4209H37.4829V12.5887V17.528C37.4829 20.0824 38.5714 21.83 41.1252 22.1897C41.1766 22.2021 41.2268 22.2115 41.2734 22.2121H41.3201C41.5817 22.2416 41.8493 22.2611 42.1286 22.2611H46.8559V19.8591H42.1493C41.3378 19.8591 40.0391 19.4587 40.0391 17.6372Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M48.6719 14.4325V22.2633H51.228V14.3811V7.41602H48.6719V14.4325Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M58.5578 11.1875C55.3265 11.1875 52.9092 13.4129 52.9092 16.8792V16.9654C52.9092 20.3461 55.2415 22.5284 58.6221 22.5284C60.2481 22.5284 61.7671 22.0789 63.158 20.6024L61.6177 19.1046C60.8044 19.9179 60.013 20.3461 58.7078 20.3461C56.8037 20.3461 55.5409 19.2334 55.4553 17.5218H63.8431C63.8862 17.0936 63.8862 16.6235 63.8862 16.6235C63.8856 13.6061 61.7671 11.1875 58.5578 11.1875ZM55.5191 15.724C55.626 14.4187 56.9531 13.3704 58.5578 13.3704C60.0555 13.3704 61.2752 14.4406 61.2752 15.724H55.5191Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M71.0679 13.4778C72.2232 13.4778 73.079 13.906 73.8066 14.6549L75.3906 13.0071C74.1492 11.68 72.6726 11.1455 71.0685 11.1455C67.8161 11.1455 65.2056 13.5635 65.2056 16.8585C65.2056 20.1535 67.8161 22.572 71.0685 22.572C72.6732 22.572 74.1497 22.0369 75.3906 20.7104L73.8066 19.0626C73.0796 19.8121 72.2232 20.2391 71.0679 20.2391C69.1851 20.2391 67.7511 18.8057 67.7511 16.8585C67.7511 14.9118 69.1851 13.4778 71.0679 13.4778Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M79.5371 17.6389H79.5342V13.8483H81.8594V11.5261H79.5377V7.41602H76.981V12.7415V17.7906L76.9886 17.7901C77.0613 20.2021 78.1574 21.8452 80.6238 22.1919C80.6752 22.2043 80.7254 22.2137 80.7715 22.2149H80.8187C81.0798 22.2439 81.3479 22.2633 81.6273 22.2633H81.8972L81.9072 19.8619H81.6486C80.8359 19.8613 79.5371 19.4603 79.5371 17.6389Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M86.5453 13.1235V11.5271H84.0098V16.7882V22.2632H86.5453V16.6175C86.5453 14.8498 87.6739 13.7419 89.441 13.7419C89.8462 13.7419 90.2088 13.7844 90.5071 13.8488V11.3777C90.4002 11.3564 90.0174 11.3145 89.7404 11.3145C88.206 11.3139 87.0561 12.0167 86.5453 13.1235Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M96.7573 11.208C93.4971 11.208 90.8984 13.6785 90.8984 16.8956C90.8984 20.1109 93.4971 22.5837 96.7573 22.5837C99.9944 22.5837 102.615 20.1109 102.615 16.8956C102.615 13.6779 99.995 11.208 96.7573 11.208ZM96.7573 20.2615C94.8614 20.2615 93.4345 18.7914 93.4345 16.8956C93.4345 14.9991 94.8614 13.5297 96.7573 13.5297C98.6325 13.5297 100.08 14.9991 100.08 16.8956C100.08 18.7908 98.6325 20.2615 96.7573 20.2615Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M104.187 14.1761V22.2633H106.745V14.2789V7.41602H104.187V14.1761Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M115.964 17.7687C115.964 19.4726 114.963 20.1979 113.62 20.1979C112.278 20.1979 111.277 19.472 111.277 17.7911V11.5283H108.699V14.6379V18.0043C108.699 21.072 110.936 22.542 113.599 22.542C116.283 22.542 118.54 21.0513 118.54 17.9406V14.6385V11.5289H115.964V17.7687Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M128.212 18.8312L126.601 16.5763L128.597 13.8571L130.306 11.5283H127.516L125.194 14.7442L122.85 11.5283H120.081L121.669 13.7L123.788 16.5981L121.567 19.6899L119.719 22.2638H122.467L125.194 18.4721L127.92 22.2638H130.668L128.212 18.8312Z"
      fill="white"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
